import _ from 'lodash';
import { v4 as uuid } from 'uuid';
const BULK_SEARCH_TYPE = 'bulk';
const SINGLE_SEARCH_TYPE = 'single';
export function mapOrganization(organization) {
    return {
        name: organization.name,
        domain: organization.web,
        position: organization.position || '',
        time: organization.time,
        isCurrentJob: organization.is_current_job === 'YES',
        companyLid: organization.company_lid,
    };
}
export function mapCurrentPosition(currentPosition) {
    return {
        name: currentPosition.companyName,
        position: currentPosition.title,
        isCurrentJob: currentPosition.current,
        companyLid: currentPosition.company_lid,
    };
}
export function mapSingleSearchData(searchData, isPluginOpen = false) {
    const contactId = uuid();
    const data = searchData.data || searchData.parsedData || searchData; // old parsers returns parsedData
    // LinkedIn restriction. so we send only current job using api
    const organizationsActive = _.filter(data.organizations, item => {
        return item.is_current_job === 'YES';
    });
    return {
        metadata: {
            searchType: SINGLE_SEARCH_TYPE,
            requestId: searchData.request_id,
            parserType: searchData.metadata.parserType,
            isUnifiedParser: searchData.metadata.isUnifiedParser,
            sourcePlatform: data.source_platform,
            url: searchData.url,
            isPluginOpen,
            sessionId: searchData.sessionId,
            platform: searchData.metadata.platform,
            indicatorNotFound: searchData.metadata.indicatorNotFound,
            indicatorSelector: searchData.metadata.indicatorSelector,
            parserCategory: searchData.metadata.parserCategory,
            status: searchData.status,
        },
        contacts: [
            {
                contactId,
                fullName: data.full_name,
                experienceParsed: data.experienceParsed || data.experience_parsed,
                organizations: _.map(organizationsActive, mapOrganization),
                headline: data.headline,
                linkedinHeaderCompany: data.linkedinHeaderCompany,
                linkedinHeaderJobTitle: data.linkedinHeaderJobTitle,
                socialLink: (data === null || data === void 0 ? void 0 : data.socialLink) || data.link,
            },
        ],
    };
}
export function mapBulkSearchData(searchData, isPluginOpen) {
    return {
        metadata: {
            searchType: BULK_SEARCH_TYPE,
            requestId: uuid(),
            parserType: searchData.metadata.parserType,
            isUnifiedParser: searchData.metadata.isUnifiedParser,
            sourcePlatform: searchData.source_platform,
            url: searchData.url,
            isPluginOpen,
            sessionId: searchData.sessionId,
            platform: searchData.metadata.platform,
            indicatorNotFound: searchData.metadata.indicatorNotFound,
            indicatorSelector: searchData.metadata.indicatorSelector,
            parserCategory: searchData.metadata.parserCategory,
            contactsOnPage: searchData.metadata.contactsOnPage,
            contactsParsed: searchData.metadata.contactsParsed,
        },
        contacts: searchData.contacts.map(contact => {
            const contactId = uuid();
            return {
                contactId,
                fullName: contact.fullName,
                socialLink: contact.socialLink,
                organizations: contact.currentPositions.map(mapCurrentPosition),
                headline: contact.headline,
                linkedinHeaderCompany: contact.linkedinHeaderCompany,
                linkedinHeaderJobTitle: contact.linkedinHeaderJobTitle,
            };
        }),
    };
}
